<mat-toolbar color="primary">
  <div class="w-full h-full flex items-center justify-between">
    <div class="flex items-center gap-2 min-w-0">
      <button *ngIf="showSideBarToggler" (click)="sideBarToggler()" mat-icon-button aria-label="Menu">
        <div class="flex items-center justify-center w-7 h-7 rounded"
             [ngClass]="sideBarOpen ? 'bg-accent' : 'bg-default-dark'">
          <!-- The badge behind it flips between `bg-accent` and `bg-default-dark`, so the glyph
               takes each one's own contrast token rather than a fixed green. -->
          <mat-icon svgIcon="ph-regular-list" [ngClass]="sideBarOpen ? 'text-accent-contrast' : 'text-default-light'"></mat-icon>
        </div>
      </button>
      <span *ngIf="greeting as text" class="font-semibold whitespace-nowrap" [ngClass]="sideBarOpen ? 'text-primary' : 'text-default-dark'">
        {{ text }}
      </span>
    </div>
    <span class="shrink-0">
      <div class="flex items-start justify-center h-12 px-2 py-1">
        <img class="h-full w-full max-w-24 object-contain" src='assets/img/toolbar_logo.png'>
      </div>
    </span>
  </div>
</mat-toolbar>
